<app-academies-header></app-academies-header>
<section class="body-section academies-profile-inner">
    <div class="container">
        <main>
            <p-toast key="toastmsg"></p-toast>
            <div class=" col-md-12 bottom-container tablesections ">
                <div class="header-container box w-100">
                    <div class="col-md-12 d-flex justify-content-between mb-3 headers-headings">
                        <h3 class="section-header">COACHES

                        </h3>

                        <div class="add-edit-btn">
                            <ul>
                                <li>
                                    <button class="add-btn-main" data-bs-toggle="modal" (click)="openmodal()">
                                        <i class='bx bx-plus'></i> Add
                                    </button>
                                </li>
                            </ul>
                        </div>

                    </div>
                    <div class="col-md-12 coatch p-0">
                        <div class="coach-list">

                            <div *ngFor="let coach of coachData " class="swiper-slide">
                                <div class="blog_card">
                                    <div class="edit-button-show-click">
                                        <button data-bs-toggle="modal" (click)="onClickEdit(coach.id)"><i
                                                class='bx bx-pencil'></i></button>
                                        <button data-bs-toggle="modal" class="delete-btn"
                                            (click)="onClickDelete(coach)"><i class='bx bx-trash'></i></button>
                                    </div>
                                    <div class="image">
                                        <img src="{{coach.image}}" alt="">
                                    </div>
                                    <div class="header-heading">
                                        <h4>{{coach.coachName}}</h4>
                                        <h6>{{coach.coachRole}}</h6>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</section>
<!-- Modal -->
<p-dialog [closable]="true" header="Header" [(visible)]="showingForm" [modal]="true" [style]="{width: '24vw'}"
    [breakpoints]="{'960px': '60vw', '768px': 'calc(100% - 30px)'}" [baseZIndex]="10000" (onHide)="onHighlightModalClose()"
    [draggable]="false" [resizable]="false" class=" add-edit-modal">
    <ng-template pTemplate="header">
        <span class="text-xl font-bold">{{pagetitle}}</span>
    </ng-template>
    <div class="modal-body">
        <form class="form" [formGroup]="coachform" (ngSubmit)="onsubmit()">
            <label for="name_login mb-3">Upload Image</label>
            <div class="col-md-12 upload-image-div p-0">
                <img *ngIf="showUploadedpic" id="blah" src="{{imagecoach}}" />
                <!-- <img *ngIf="!showUploadedpic" id="blah" src="assets/img/acadmy-details/180.png" alt="your image" /> -->
                <p-fileUpload name="myfile[]" maxFileSize="{{imageSize}}" customUpload="true"
                    (uploadHandler)="picUploader($event)" accept="image/*" auto="auto">
                </p-fileUpload>
            </div>
            <div class="row">
                <div class="col">
                    <div class="row mb-0">
                        <div class="p-field p-col-12  mb-0 pb-0">
                            <label for="coachName">Coach Name<span class="mandatory-fields"> *</span></label>
                            <input formControlName="coachName" type="text" pInputText class="form-control"
                                placeholder="Enter Coach Name"
                                [ngClass]="{ 'is-invalid': ((submitted && f.coachName.errors) || (f.coachName.errors && (f.coachName.dirty || f.coachName.touched))) }">
                            <div *ngIf="((submitted && f.coachName.errors) || (f.coachName.errors && (f.coachName.dirty || f.coachName.touched)))"
                                class="invalid-feedback">
                                <div *ngIf="f.coachName.errors.required">
                                    Coach Name is required.</div>
                                <div *ngIf="!f.coachName.errors.required">
                                    Please enter valid Coach Name.</div>
                            </div>
                        </div>

                        <div class="p-field p-col-12">
                            <label for="coachRole">Coach Role<span class="mandatory-fields"> *</span></label>
                            <input formControlName="coachRole" type="text" pInputText class="form-control"
                                placeholder="Enter Coach Role"
                                [ngClass]="{ 'is-invalid': ((submitted && f.coachRole.errors) || (f.coachRole.errors && (f.coachRole.dirty || f.coachRole.touched))) }">
                            <div *ngIf="((submitted && f.coachRole.errors) || (f.coachRole.errors && (f.coachRole.dirty || f.coachRole.touched)))"
                                class="invalid-feedback">
                                <div *ngIf="f.coachRole.errors.required">
                                    Coach Role is required.</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer justify-content-center">
                <button type="submit" class="btn btn-primary p-0">
                    <span *ngIf="isAddMode">Save</span>
                    <span *ngIf="!isAddMode">Update</span>
                </button>
            </div>
        </form>
    </div>
</p-dialog>
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>